import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React, { forwardRef } from "react";
import { Box, Flex } from "@catchoftheday/cg-components";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var MigrationNudgeZone = /*#__PURE__*/forwardRef(function (props, ref) {
  return ___EmotionJSX(Box, _extends({
    "data-testid": "migration-nudge-zone",
    ref: ref,
    fontFamily: "onePass",
    backgroundColor: "white",
    border: 1,
    borderColor: "ui.borderColor",
    borderRadius: "corner",
    overflow: "hidden",
    py: 6,
    px: 4
  }, props));
});
MigrationNudgeZone.displayName = "MigrationNudgeZone";
export var MigrationNudgeContentZone = function MigrationNudgeContentZone(props) {
  return ___EmotionJSX(Flex, _extends({
    flexDirection: "column",
    alignItems: "center",
    color: "textSecondary",
    mb: {
      xs: 4,
      md: 6
    }
  }, props));
};
export var MigrationNudgeDivisionsZone = function MigrationNudgeDivisionsZone(props) {
  return ___EmotionJSX(Flex, _extends({
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    fontSize: "2xl"
  }, props));
};